package it.neckar.lizergy.model.customer

import it.neckar.open.i18n.CurrentI18nConfiguration
import it.neckar.open.i18n.I18nConfiguration
import it.neckar.open.kotlin.lang.ifBlank
import it.neckar.uuid.HasUuid
import it.neckar.uuid.NativeUuid
import it.neckar.uuid.ValueClassUuid
import it.neckar.uuid.randomUuid4
import kotlinx.serialization.Serializable
import kotlin.js.JsExport
import kotlin.uuid.Uuid


/**
 * Information about the customer
 */
@JsExport
@Serializable
data class Customer(
  val id: CustomerId,

  val firstName: String,
  val lastName: String,

  /**
   * The address of the customer. *Not* the address of the location of the pv system
   */
  val address: Address = Address.empty,

  val phone: String? = null,
  val cellphone: String? = null,
  val email: String? = null,

  /**
   * The customer's company (Optional)
   */
  val company: String? = null,

  @Deprecated("That does not work here")
  val customerWish: String? = null,

  ) : HasUuid {

  override val uuid: Uuid
    get() = id.uuid

  /**
   * Returns the complete name
   */
  val completeName: String
    get() = "$firstName $lastName"

  val hasPlausibleName: Boolean
    get() = (firstName.isNotBlank() && lastName.isNotBlank()) || hasPlausibleCompanyName

  /**
   * Returns true if the customer is plausible (contains values for all relevant properties)
   */
  val isPlausible: Boolean
    get() = hasPlausibleName && address.isPlausible

  val hasPlausibleCompanyName: Boolean
    get() = company?.isNotBlank() == true

  @Suppress("UNUSED_PARAMETER")
  fun format(i18nConfiguration: I18nConfiguration = CurrentI18nConfiguration): String {
    return "$completeName, ${address.singleLine()}"
  }

  /**
   * Returns the company name - if there is one.
   * Else returns the complete name of the customer
   */
  fun companyOrCompleteName(): String {
    return company.ifBlank {
      completeName
    }
  }

  /**
   * Returns the company - if there is one.
   * Else returns the last name of the customer
   */
  fun companyOrLastName(): String {
    return company.ifBlank {
      lastName
    }
  }

  companion object {
    fun empty(uuid: Uuid = randomUuid4()): Customer = Customer(
      id = CustomerId(uuid),
      firstName = "",
      lastName = "",
    )
  }

  /**
   * An id for a customer
   */
  @Serializable
  data class CustomerId(override val uuid: NativeUuid) : ValueClassUuid {

    override fun toString(): String {
      return uuid.toString()
    }

    fun format(): String {
      return uuid.toString()
    }

    companion object {
      fun random(): CustomerId {
        return CustomerId(randomUuid4())
      }
    }
  }
}
